import React from 'react';
import sha1 from 'crypto-js/sha1';
import { apiGet, apiPost, apiPut, getHostApi, createQs, processErrorMessage, processErrorData } from './apiWrapper';
import { writeInfo, writeDebug, writeWarn } from '../components/common/logger';
import { updateObject, updateObjectProperty, updateSection } from './storeFunctions'
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { isNullOrUndefined, isFunction } from './storeFunctions';
import { userLogout } from './userContextStore';
import { errorType } from './appContextStore';
import IdentDataIcon from '../img/icons/globalReport/BBiconsGrIdentifikaceSpolecnosti';
import AmlIcon from '../img/icons/globalReport/BBiconsGrAml';
import GrantsIcon from '../img/icons/globalReport/BBiconsGrDotace';
import EvaluationsIcon from '../img/icons/globalReport/BBiconsGrHodnoceniSubjektu';
import FinStatementsIcon from '../img/icons/globalReport/BBiconsGrInformaceUcetnichZaverek';
import ITradeIcon from '../img/icons/globalReport/BBiconsGrITrade';
import ContactsIcon from '../img/icons/globalReport/BBiconsGrKontaktniUdaje';
import FinRationsIcon from '../img/icons/globalReport/BBiconsGrPomeroveUkazatele';
import ActivityIcon from '../img/icons/globalReport/BBiconsGrPredmetCinnosti';
import ChangesIcon from '../img/icons/globalReport/BBiconsGrPrehledZmen';
import GeneralAssembliesIcon from '../img/icons/globalReport/BBiconsGrValneHromady';
import PublicProcurementsIcon from '../img/icons/globalReport/BBiconsGrVerejneZakazky';
import RelationsCRSRIcon from '../img/icons/globalReport/BBiconsGrVztahyCRSR';
import RelationsIcon from '../img/icons/globalReport/BBiconsGrVztahy';
import BasicInfoIcon from '../img/icons/globalReport/BBiconsGrZakladniUdajeSpolecnosti';
import LiensIcon from '../img/icons/globalReport/BBiconsGrZastavniPrava';
import PublicContractsIcon from '../img/icons/globalReport/BBiconsGrZverejneneSmlouvy';
import WarningsIcon from '../img/icons/BBiconsVi';
import PoIcon from '../img/icons/PravnickaOsoba';
import FoIcon from '../img/icons/FyzickaOsoba';
import MonitoraIcon from '../img/icons/BBiconsMonitora';
import MonitoraAnnotationIcon from '../img/icons/BBiconsMonitoraPrehledClanku';
import FinDataUpdateIcon from '../img/icons/BBiconsAktualizace';
import EssMspIcon from '../img/icons/ess/Msp';
import EssIcon from '../img/icons/ess/Ess';
import EssHodnoceniIcon from '../img/icons/ess/Hodnoceni';
import BBiconsAuta from '../img/icons/globalReport/BBiconsAuta';
import BBiconsESG from '../img/icons/globalReport/BBiconsESG';
import BBIconsESGDataSources from '../img/icons/BBicons_ESG-Zdroje_dat';
import BBIconsESGMethodology from '../img/icons/BBicons_ESG-Metodologie';
import BBIconsESGScoreG from '../img/icons/BBicons_ESG_G_skore';
import BBIconsESGScoreS from '../img/icons/BBicons_ESG_S_skore';
import BBIconsESGScoreE from '../img/icons/BBicons_ESG_E_skore';
import BBIconsESGDetailScore from '../img/icons/BBicons_ESG_Detail_skore';

import SvgBBiconsPohledavky from '../img/icons/globalReport/BBiconsPohledavky';
import CeeIcon from '../img/icons/leftPanel/BBiconsBmExekuceCz';
import ReliabilityIcon from '../img/icons/BBiconsDozReport';
import RepiIcon from '../img/icons/leftPanel/BBiconsRepi';
import CompanyInDifficultyIcon from '../img/icons/BBicons_CompanyInDifficulty';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value
const requestGetReportType = "REQUEST_REPORT";
const receiveGetReportType = "RECEIVE_REPORT";
const errorGetReportType = "RECEIVE_REPORT_ERROR";
const requestReportSection = "REQUEST_REPORT_SECTION";
const updateReportSection = "UPDATE_REPORT_SECTION";
const errorReportSection = "UPDATE_REPORT_SECTION_ERROR";
const attachElement = "ATTACH_SECTION";
const expandSection = "EXPAND_SECTION";
const sectionIdPdf = "SECTION_IN_PDF";
const exportReportToPdf = "EXPORT_REPORT_TO_PDF";
const expandSubsection = "EXPAND_SUBSECTION";
const reorderSections = "REORDER_SECTIONS";
const toggleShow = "TOGGLE_SHOW";
const reportEntering = 'ENTERING_REPORT';
const reportLeaving = 'LEAVING_REPORT';
const createConfigSnapshotType = 'CREATE_REPORT_CONFIG_SNAPSHOT';
const restoreConfigType = 'RESTORE_REPORT_CONFIG_FROM_SNAPSHOT';
const saveConfigType = 'SAVE_REPORT_CONFIG';
const toggleShowAllSectionsType = 'SHOW_HIDE_ALL_REPORT_SECTIONS';
const expandAllSections = 'EXPAND_ALL_SECTIONS';
const hideAllSections = 'HIDE_ALL_SECTIONS';
const toggleSectionsMenuEditType = 'SET_REPORT_SECTION_MENU_EDIT_MODE';
const moreSectionData = "MORE_SECTION_DATA";
const moreSectionDataSuccess = "MORE_SECTION_DATA_SUCCESS";
const moreSectionDataError = "MORE_SECTION_DATA_ERROR";
const expandSimpleSubsection = 'EXPAND_SIMPLE_SUBSECTION';
const sectionFocusedType = 'SECTION_FOCUSED';
const sectionParamChange = 'SECTION_PARAM_CHANGE';
const reportReload = 'REPORT_RELOAD';
const cancelReportReload = 'REPORT_RELOAD_CANCEL';
const sectionFocusChanged = "SECTION_FOCUS_CHANGED";
const sectionScrollRequest = "SECTION_SCROLL_REQUEST";
const relatedAddressRequest = "RELATED_ADDRESS_REQUEST";
const relatedAddressSuccess = "RELATED_ADDRESS_SUCCESS";
const relatedAddressError = "RELATED_ADDRESS_ERROR";
const essDefaultShare = "ESS_DEFAULT_SHARE";
const egDataLoaded = "EG_DATA_LOADED";
const saveEconomicGroupEntity = "SAVE_ECONOMIC_GROUP_ENTITY";
const setCustomizableMspImportData = "SET_CUSTOMIZABLE_MSP_IMPORT_DATA";
const companyInDifficultyExportUsedChange = "COMPANY_IN_DIFFICULTY_EXPORT_USED_CHANGE";

export const REPORTS = {
    global: "GlobalReport",
    naturalPerson: "NaturalPersonReport",
    short: "ShortReport",
    quick: "QuickReport",
    quickAddress: "QuickAddressReport",
    warnings: "WarningsReport",
    vehicles: "VehicleReport",
    mirri: "MirriReport",
    customizableMsp: "CustomizableMspReport",
    esg: "ESGReport"
};

export const SECTIONS = {
    identData: "IdentData",
    contactData: "ContactData",
    warningData: "WarningData",
    ratingData: "RatingData",
    finStatementsData: "FinStatementsData",
    finRatiosData: "FinRatiosData",
    subjectActivity: "SubjectActivity",
    publicContracts: "PublicContracts",
    grantsData: "GrantsData",
    amlInfoCheck: "AmlInfoCheck",
    finStatementsIfrsData: "FinStatementsIfrsData",
    basicInfo: "BasicInfo",
    iTrade: "ITrade",
    relationsData: "RelationsData",
    generalAssembliesData: "GeneralAssembliesData",
    liens: "Liens",
    publicProcurements: "PublicProcurements",
    alerts: "Alerts",
    naturalIdentData: "NaturalIdentData",
    simpleAccounting: "SimpleAccounting",
    economicGroupSme: "EconomicGroupSme",
    quickReport: "QuickReport",
    economicGroupData: "EconomicGroupData",
    quickAddressReport: "QuickAddressReport",
    economicGroupEvaluation: "EconomicGroupEvaluation",
    quickReportRelations: "QuickReportRelations",
    quickAddressReportRelations: "QuickAddressReportRelations",
    shortReport: "ShortReport",
    shortReportRatingData: "ShortReportRatingData",
    shortReportWarningData: "ShortReportWarningData",
    shortReportRelationsData: "ShortReportRelationsData",
    shortReportBasicInfo: "ShortReportBasicInfo",
    shortReportITrade: "ShortReportITrade",
    quickReportFinStatementsInfo: "QuickReportFinStatementsInfo",
    quickReportFinDataUpdate: "QuickReportFinDataUpdate",
    monitoraTeaser: "MonitoraTeaser",
    monitoraAnnotation: "MonitoraAnnotation",
    registeredVehicles: "RegisteredVehicles",
    warningsReport: "WarningsReport",
    warningsReportWarningData: "WarningsReportWarningData",
    recievables: "Recievables",
    listOfVehicles: "ListOfVehicles",
    vehiclesOverview: "VehiclesOverview",
    reliabilityReport: "ReliabilityReport",
    reliabilityCEE: "ReliabilityCEE",
    reliabilityAML: "ReliabilityAML",
    relationsCRSRData: "RelationsCRSRData",
    shortReportRelationsCRSRData: "ShortReportRelationsCRSRData",
    repiReportIdentification: "RepiReportIdentification",
    repiReportContactHistory: "RepiReportContactHistory",
    repiReportPaymentHistory: "RepiReportPaymentHistory",
    repiReportDocumentHistory: "RepiReportDocumentHistory",
    repiITrade: "RepiITrade",
    repiPaymentHistoryDataCorrection: "RepiPaymentHistoryDataCorrection",
    repiSubjectDataCorrection: "RepiSubjectDataCorrection",
    restReliabilityReport: "RestReliabilityReport",
    repiTeaser: "RepiTeaser",
    shortReportRepiTeaser: "ShortReportRepiTeaser",
    mirriRatingData: "MirriRatingData",
    mirriORSRDataRecap: "MirriORSRDataRecap",
    mirriRelationsData: "MirriRelationsData",
    mirriPersonalRelations: "MirriPersonalRelations",
    mirriPublicContracts: "MirriPublicContracts",
    mirriWarningData: "MirriWarningData",
    mirriGrantsData: "MirriGrantsData",
    mirriIdentData: "MirriIdentData",
    esg: "ESG",
    industryRegionData: "IndustryRegionData", //not in db
    esgIdentData: "ESGIdentData",
    esgScoreOverview: "ESGScoreOverview",
    esgScoreDetail: "ESGScoreDetail",
    esgScoreE: "ESGScoreE",
    esgScoreS: "ESGScoreS",
    esgScoreG: "ESGScoreG",
    esgMethodology: "ESGMethodology",
    esgDataSources: "ESGDataSources",
    esgReporting: "ESGReporting",
    // sub sections
    publicContractsItems: "PublicContractsItems",
    amlInfoCheckResultGlobalEval: "AmlInfoCheckResultGlobalEval",
    amlInfoCheckResultSubjectEval: "AmlInfoCheckResultSubjectEval",
    relatedAddresses: "RelatedAddresses",
    liensItems: "LiensItems",
    economicGroupStructure: "EconomicGroupStructure",
    economicGroupEvaluationDetails: "EconomicGroupEvaluationDetails",
    economicGroupAdditionalInformation: "EconomicGroupAdditionalInformation",
    essFinalOwners: "EssFinalOwners",
    shortReportRelatedAddresses: "ShortReportRelatedAddresses",
    warningItems: "WarningItems",
    warningsReportWarningItems: "WarningsReportWarningItems",
    shortReportWarningItems: "ShortReportWarningItems",
    relationItems: "RelationItems",
    relationCRSRItems: "RelationCRSRItems",
    mirriRelatedAddresses: "MirriRelatedAddresses",
    mirriPublicSectorPartner: "MirriPublicSectorPartner",
    mirriFinalOwner: "MirriFinalOwner",
    mirriPublicContractsItems: "MirriPublicContractsItems",
    mirriWarningItems: "MirriWarningItems",
    companyInDifficulty: "CompanyInDifficulty",
    esgSubfactorsE: "ESGSubfactorsE",
    esgSubfactorsS: "ESGSubfactorsS",
    esgSubfactorsG: "ESGSubfactorsG",
    finStatementsInfo: "FinStatementsInfo"
}

const SECTION_LIMITS = [
    { id: SECTIONS.warningData, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.warningItems}_WarningsInfo`, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_InsolvencyRegister`, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_InsolvencyRegisterAll`, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_Debts`, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_SupplementaryInfo`, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },

    { id: SECTIONS.mirriWarningData, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.mirriWarningItems}_WarningsInfo`, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.mirriWarningItems}_InsolvencyRegister`, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.mirriWarningItems}_InsolvencyRegisterAll`, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.mirriWarningItems}_Debts`, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },

    { id: SECTIONS.warningData, report: REPORTS.naturalPerson, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.warningItems}_WarningsInfo`, report: REPORTS.naturalPerson, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_InsolvencyRegister`, report: REPORTS.naturalPerson, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_InsolvencyRegisterAll`, report: REPORTS.naturalPerson, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_Debts`, report: REPORTS.naturalPerson, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningItems}_SupplementaryInfo`, report: REPORTS.naturalPerson, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },

    { id: SECTIONS.shortReportWarningData, report: REPORTS.short, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.shortReportWarningItems}_WarningsInfo`, report: REPORTS.short, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.shortReportWarningItems}_InsolvencyRegister`, report: REPORTS.short, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.shortReportWarningItems}_InsolvencyRegisterAll`, report: REPORTS.short, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.shortReportWarningItems}_Debts`, report: REPORTS.short, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.shortReportWarningItems}_SupplementaryInfo`, report: REPORTS.short, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },

    { id: SECTIONS.warningsReportWarningData, report: REPORTS.warnings, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.warningsReportWarningItems}_WarningsInfo`, report: REPORTS.warnings, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningsReportWarningItems}_InsolvencyRegister`, report: REPORTS.warnings, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningsReportWarningItems}_InsolvencyRegisterAll`, report: REPORTS.warnings, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningsReportWarningItems}_Debts`, report: REPORTS.warnings, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.warningsReportWarningItems}_SupplementaryInfo`, report: REPORTS.warnings, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },

    { id: `${SECTIONS.quickReport}|${SECTIONS.quickReportRelations}`, report: REPORTS.quick, pageSize: { limited: 100, unlimited: 100 } },
    { id: `${SECTIONS.quickAddressReport}|${SECTIONS.quickAddressReportRelations}`, report: REPORTS.quickAddress, pageSize: { limited: 100, unlimited: 100 } },
    { id: SECTIONS.grantsData, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: SECTIONS.mirriGrantsData, report: REPORTS.mirri, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },

    { id: SECTIONS.relationsCRSRData, report: REPORTS.global, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationCRSRItems, report: REPORTS.global, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.mirriORSRDataRecap, report: REPORTS.mirri, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationCRSRItems, report: REPORTS.mirri, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.shortReportRelationsCRSRData, report: REPORTS.short, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationCRSRItems, report: REPORTS.short, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.relationsData, report: REPORTS.global, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationItems, report: REPORTS.global, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.mirriRelationsData, report: REPORTS.mirri, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationItems, report: REPORTS.mirri, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },
    { id: SECTIONS.mirriPersonalRelations, report: REPORTS.mirri, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.shortReportRelationsData, report: REPORTS.short, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationItems, report: REPORTS.short, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.relationsData, report: REPORTS.naturalPerson, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: SECTIONS.relationItems, report: REPORTS.naturalPerson, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },

    { id: SECTIONS.relatedAddresses, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: SECTIONS.relatedAddresses, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: SECTIONS.generalAssembliesData, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 100 } } },
    { id: SECTIONS.alerts, report: REPORTS.global, pageSize: { limited: 200, unlimited: 100 }, params: { limited: { count: 200 }, unlimited: { count: 100 } } },
    { id: SECTIONS.liens, report: REPORTS.global, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.liensItems}_CR`, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.liensItems}_DE`, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: SECTIONS.liens, report: REPORTS.naturalPerson, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.liensItems}_CR`, report: REPORTS.naturalPerson, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.liensItems}_DE`, report: REPORTS.naturalPerson, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: SECTIONS.publicProcurements, report: REPORTS.global, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.publicProcurements}_S`, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.publicProcurements}_A`, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: SECTIONS.publicContracts, report: REPORTS.global, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.publicContractsItems}_01`, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.publicContractsItems}_02`, report: REPORTS.global, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: SECTIONS.mirriPublicContracts, report: REPORTS.mirri, params: { limited: { limited: true }, unlimited: { limited: false } } },
    { id: `${SECTIONS.mirriPublicContractsItems}_01`, report: REPORTS.mirri, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: `${SECTIONS.mirriPublicContractsItems}_02`, report: REPORTS.mirri, pageSize: { limited: 50, unlimited: 100 }, params: { limited: { count: 50 }, unlimited: { count: 100 } } },
    { id: SECTIONS.contactData, report: REPORTS.global, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 50 } } },
    { id: SECTIONS.contactData, report: REPORTS.mirri, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 50 } } },
    { id: SECTIONS.listOfVehicles, report: REPORTS.vehicles, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 50 } } },

    { id: SECTIONS.quickReport, report: REPORTS.CustomizableMspReport, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 50 } } },
    { id: SECTIONS.economicGroupSme, report: REPORTS.CustomizableMspReport, pageSize: { limited: 100, unlimited: 100 }, params: { limited: { count: 100 }, unlimited: { count: 50 } } }

];

let loadedReportConfig = { url: '', language: '' };

const initialState = {
    id: null,
    reportType: null,
    isLoading: false,
    isExpandAllActivated: false,
    isHideAllActivated: false,
    showHideAllSections: false,
    isPdfExportEnabled: true,
    sectionToFocus: null,
    requestedReload: false,
    relatedAddress: { id: null, data: null, isLoading: false, error: null },
    repi: { calculationDate: new Date() },
    economicGroupSettings: { filter: 'EG', share: 60, entityID: null, reload: false },
    customizableMspImportData: { hasItems: false, items: [], invalidFile: false },
    companyInDifficultyExportUsed: false
};

const requestFetchSectionData = (path, data) => async (dispatch, getState) => {
    if (!Array.isArray(path))
        requestFetchSection(path, data, dispatch, getState);

    if (path.length < 1)
        return;

    let sec = getSection(getState().report.sections, path.slice(0));
    if (sec === undefined || sec === null || sec.url === null || sec.url === undefined) {
        dispatch({ type: errorReportSection, path: path.slice(0), err: "failed to determine url" });
        return;
    }

    if (sec.data === null || sec.data === undefined) {
        const newParams = Object.assign({}, sec.params, data, { report: getState().report.reportType, guid: sec.guid });
        dispatch({ type: requestReportSection, path: path.slice(0), params: newParams });
        apiGet(sec.url, newParams,
            res => {
                dispatch({ type: updateReportSection, path: path.slice(0), ...res });
                manageSectionStatusCheckScheduler(path, dispatch, getState, res.ok ? res.data : undefined);
            },
            err => {
                dispatch({ type: errorReportSection, path: path.slice(0), err: processErrorMessage(err) });
                manageSectionStatusCheckScheduler(path, dispatch, getState);
            }
        );
    }
}

const requestGetReportSettings = (id, reportType, sectionFilter = null) => async (dispatch, getState) => {
    if (id === getState().report.id && reportType === getState().report.reportType && getState().report.requestedReload === false) {
        dispatch({ type: reportEntering });
        return;
    }

    const baseUrl = getBaseUrl({ reportType, id, sectionFilter });

    if (baseUrl === loadedReportConfig.url && getState().userContext.language === loadedReportConfig.language && getState().report.requestedReload === false)
        return;

    loadedReportConfig = { url: baseUrl, language: getState().userContext.language };

    // dispatch event to allow loading indication
    dispatch({ type: requestGetReportType });
    apiGet(baseUrl, undefined,
        res => {
            if (res.error) {
                dispatch({ type: errorGetReportType, err: res.error });
                dispatch({ type: errorType, message: processErrorMessage({ data: res }, "UnhappyUser.ReportError") });
            } else {
                const processedSections = updateSubsections(res.data, baseUrl, id);
                dispatch({ type: receiveGetReportType, id, reportType, data: processedSections });
                dispatch({ type: reportEntering, focusedSectionId: ((processedSections.filter(x => !x.hidden)[0] || {}).id) || '' });
            }
        },
        err => {
            dispatch({ type: errorGetReportType, err });
            dispatch({ type: errorType, message: processErrorMessage(err, "UnhappyUser.ReportError"), messageData: processErrorData(err) });
        }
    );
}

const requestGetRepiReportSettings = (id, reportType, url, params, forceReload = false) => async (dispatch, getState) => {
    const reload = getState().report.requestedReload || forceReload;
    if (id === getState().report.id && reportType === getState().report.reportType && reload === false) {
        dispatch({ type: reportEntering });
        return;
    }

    if (url === loadedReportConfig.url && getState().userContext.language === loadedReportConfig.language && reload === false)
        return;

    loadedReportConfig = { url: url, language: getState().userContext.language };

    // dispatch event to allow loading indication
    dispatch({ type: requestGetReportType });
    apiGet(`${window.babylonApiUrl}/api/repi/report/${reportType}/${id}/config`, params,
        res => {
            if (res.error) {
                dispatch({ type: errorGetReportType, err: res.error });
                dispatch({ type: errorType, message: processErrorMessage({ data: res }, "UnhappyUser.ReportError") });
            } else {
                const processedSections = updateSubsections(res.data, url, id, undefined, reportType);
                dispatch({ type: receiveGetReportType, id: id, reportType: "Repi" + reportType, data: processedSections });
                dispatch({ type: reportEntering, focusedSectionId: ((processedSections.filter(x => !x.hidden)[0] || {}).id) || '' });
            }
        },
        err => {
            dispatch({ type: errorGetReportType, err });
            dispatch({ type: errorType, message: processErrorMessage(err, "UnhappyUser.ReportError"), messageData: processErrorData(err) });
        }
    );
}

const reloadReport = () => async (dispatch, getState) => {
    dispatch({ type: reportReload });
}

const postSectionRequest = (sectionId) => async (dispatch, getState) => {
    dispatch({ type: requestReportSection, path: sectionId.slice(0) });
    apiPost(getSection(getState().report.sections, sectionId.slice(0)).url, undefined, undefined,
        () => requestFetchSection(sectionId.slice(0), undefined, dispatch, getState),
        err => dispatch({ type: errorReportSection, path: sectionId.slice(0), err: processErrorMessage(err) }));
}

const setSectionParams = (sectionId, newParams, after) => async (dispatch, getState) => {
    writeDebug('Updating section params', newParams);
    dispatch({ type: sectionParamChange, sectionId: sectionId.slice(0), newParams });
    updateSingleSectionConfig(getState().report.reportType, getSection(getState().report.sections, sectionId.slice(0)), after);
}

const setSectionInPdf = (sectionId, inPdf, historyInPdf) => async (dispatch, getState) => {
    dispatch({ type: sectionIdPdf, sectionId: [sectionId], inPdf, historyInPdf });
    updateSingleSectionConfig(getState().report.reportType, { ...getSection(getState().report.sections, [sectionId]), inPdf, historyInPdf });
}

const exportPdf = (entityId) => async (dispatch, getState) => {
    dispatch({ type: exportReportToPdf });
    const data = {
        report: getState().report.reportType,
        settings: {
            sections: getState().report.sections.filter(x => x.inPdf && x.hidden === false)
                .map(x => { return { id: x.id, params: createQs(x.params || {}), expanded: true, guid: x.guid } })
        },
        id: parseInt(entityId),
        customizableMspData: getState().report.customizableMspImportData
    };
    apiPost(getHostApi() + '/api/report/export-pdf-entity', undefined, data);
}

const toggleSection = (sectionId, newExpanded, save) => async (dispatch, getState) => {
    expandIfNeeded(sectionId.slice(0), dispatch, getState, newExpanded, false);
    writeDebug('Toggling section ' + sectionId.slice(0) + ' new state:' + newExpanded);
    dispatch({ type: expandSection, sectionId: sectionId.slice(0), newExpanded });
    if (save)
        updateSingleSectionConfigDebounced(getState().report.reportType, getSection(getState().report.sections, sectionId.slice(0)));
}

const toggleSubsection = (sectionId, subsectionId, newExpanded, save) => async (dispatch, getState) => {
    toggleSection([sectionId, subsectionId], newExpanded, save)(dispatch, getState);
}

const onToggleShow = (sectionId, newHidden, dispatch) => {
    dispatch({ type: toggleShow, sectionId: sectionId.slice(0), newHidden });
}

const saveSections = async (dispatch, getState) => {
    dispatch({ type: saveConfigType, sections: getState().report.sections.slice(0) });
    updateSectionsConfigDebounced(getState().report.reportType, getState().report.sections);
}

const onLeavingReport = dispatch => {
    cancelAllTimers();
    dispatch({ type: reportLeaving });
}

const getUnlimitedSectionLink = (report, entityId, sectionId) => (_) => {
    // sanitize input values
    const reportType = Object.keys(REPORTS).find(k => REPORTS[k] === report);
    const entId = parseInt(entityId);
    const secId = Object.keys(SECTIONS).find(k => SECTIONS[k] === sectionId);
    return isNullOrUndefined(reportType) || isNaN(entId) || isNullOrUndefined(secId) ? "#" : `/unlimited/${reportType}/${entId}/${SECTIONS[secId]}`;
}

const getSectionIcon = (sectionId) => {
    switch (sectionId) {
        case SECTIONS.identData:
        case SECTIONS.mirriIdentData:
        case SECTIONS.shortReport:
        case SECTIONS.quickReport:
        case SECTIONS.warningsReport:
        case SECTIONS.vehiclesOverview:
        case SECTIONS.repiReportIdentification:
            return IdentDataIcon;
        case SECTIONS.warningData:
        case SECTIONS.mirriWarningData:
        case SECTIONS.shortReportWarningData:
        case SECTIONS.warningsReportWarningData:
            return WarningsIcon;
        case SECTIONS.contactData:
        case SECTIONS.repiReportContactHistory:
            return ContactsIcon;
        case SECTIONS.esg:
        case SECTIONS.esgIdentData:
        case SECTIONS.esgScoreOverview:
        case SECTIONS.esgReporting:
            return BBiconsESG;
        case SECTIONS.esgScoreDetail:
            return BBIconsESGDetailScore;
        case SECTIONS.esgScoreE:
            return BBIconsESGScoreE;
        case SECTIONS.esgScoreS:
            return BBIconsESGScoreS;
        case SECTIONS.esgScoreG:
            return BBIconsESGScoreG;
        case SECTIONS.esgMethodology:
            return BBIconsESGMethodology;
        case SECTIONS.esgDataSources:
            return BBIconsESGDataSources;
        case SECTIONS.ratingData:
        case SECTIONS.mirriRatingData:
        case SECTIONS.shortReportRatingData:
            return EvaluationsIcon;
        case SECTIONS.finStatementsData:
        case SECTIONS.quickReportFinStatementsInfo:
        case SECTIONS.repiPaymentHistoryDataCorrection:
        case SECTIONS.repiReportPaymentHistory:
        case SECTIONS.finStatementsInfo:
            return FinStatementsIcon;
        case SECTIONS.finRatiosData: return FinRationsIcon;
        case SECTIONS.subjectActivity: return ActivityIcon;
        case SECTIONS.mirriPublicContracts:
        case SECTIONS.publicContracts: return PublicContractsIcon;
        case SECTIONS.industryRegionData: return PoIcon;
        case SECTIONS.grantsData:
        case SECTIONS.mirriGrantsData: return GrantsIcon;
        case SECTIONS.reliabilityAML:
        case SECTIONS.amlInfoCheck: return AmlIcon;
        case SECTIONS.basicInfo:
        case SECTIONS.shortReportBasicInfo:
        case SECTIONS.repiSubjectDataCorrection:
            return BasicInfoIcon;
        case SECTIONS.iTrade:
        case SECTIONS.repiITrade:
        case SECTIONS.shortReportITrade:
            return ITradeIcon;
        case SECTIONS.relatedAddresses:
        case SECTIONS.relationsData:
        case SECTIONS.shortReportRelationsData:
        case SECTIONS.mirriRelationsData:
            return RelationsIcon;
        case SECTIONS.relationsCRSRData:
        case SECTIONS.shortReportRelationsCRSRData:
        case SECTIONS.mirriORSRDataRecap:
        case SECTIONS.mirriPersonalRelations:
            return RelationsCRSRIcon;
        case SECTIONS.liens: return LiensIcon;
        case SECTIONS.publicProcurements: return PublicProcurementsIcon;
        case SECTIONS.alerts: return ChangesIcon;
        case SECTIONS.generalAssembliesData: return GeneralAssembliesIcon;
        case SECTIONS.economicGroupSme: return EssMspIcon;
        case SECTIONS.economicGroupData: return EssIcon;
        case SECTIONS.essFinalOwners: return RelationsCRSRIcon;
        case SECTIONS.economicGroupEvaluation: return EssHodnoceniIcon;
        case SECTIONS.monitoraTeaser: return MonitoraIcon;
        case SECTIONS.monitoraAnnotation: return MonitoraAnnotationIcon;
        case SECTIONS.quickReportFinDataUpdate: return FinDataUpdateIcon;
        case SECTIONS.naturalIdentData: return FoIcon;
        case SECTIONS.registeredVehicle:
        case SECTIONS.listOfVehicles:
            return BBiconsAuta;
        case SECTIONS.recievables: return SvgBBiconsPohledavky;
        case SECTIONS.reliabilityCEE: return CeeIcon;
        case SECTIONS.reliabilityReport: return ReliabilityIcon;
        case SECTIONS.repiTeaser:
        case SECTIONS.shortReportRepiTeaser:
            return RepiIcon;
        case SECTIONS.companyInDifficulty: return CompanyInDifficultyIcon;
        default: return PoIcon;
    }
}

//action creator for redux
export const reportActions = {
    requestGetReportSettings,
    requestGetRepiReportSettings,
    requestFetchSection: (sectionId, data) => async (dispatch, getState) => requestFetchSection(sectionId, data, dispatch, getState),
    requestFetchSectionData,
    postSectionRequest,
    attachSectionElement: (sectionId, element) => async (dispatch) => dispatch({ type: attachElement, sectionId, element }),
    toggleSection,
    loadIfExpanded: (sectionId, expandState) => async (dispatch, getState) => expandIfNeeded(sectionId, dispatch, getState, expandState, true),
    onLeavingReport: () => (dispatch) => onLeavingReport(dispatch),
    requestFetchSubsection: (sectionId, subsectionId) => async (dispatch, getState) => requestFetchSectionData([sectionId, subsectionId], null, dispatch, getState),
    toggleSubsection,
    loadIfSubsectionExpanded: (sectionId, subsectionId, expandState) => async (dispatch, getState) =>
        expandIfNeeded([sectionId, subsectionId], dispatch, getState, expandState, true),
    getSection: (path) => (_, getState) => getSection(getState().report.sections, path.slice(0), 0),

    getParentSection: (path) => (_, getState) => getSection(getState().report.sections, path.slice(0), 1),
    reorderSections: sections => async (dispatch, getState) => {
        let reportSections = [...getState().report.sections];
        for (let idx = 0; idx < reportSections.length; idx++) {
            reportSections[idx].orderId = (sections.filter(x => x.id == reportSections[idx].id)[0] || {}).orderId || 0;
        }
        reportSections = reportSections.sort(function (a, b) { return a.orderId - b.orderId; });
        dispatch({ type: reorderSections, repSections: reportSections.slice(0), navSections: sections.slice(0) });
    },
    resetSectionsOrder: (sections) => async (dispatch, getState) => onResetSectionsOrder(sections, dispatch, getState),
    toggleShow: (sectionId, newHidden) => async dispatch => onToggleShow(sectionId, newHidden, dispatch),
    setSectionInPdf,
    exportPdf,
    expand: () => async (dispatch, getState) => expandAllSectionsFunc(dispatch, getState),
    collapse: () => async (dispatch, getState) => collapseAllSectionsFunc(dispatch, getState),
    getSectionIcon: sectionId => _ => getSectionIcon(sectionId),
    saveSections: () => async (dispatch, getState) => saveSections(dispatch, getState),
    createConfigSnapshot: () => (dispatch, getState) => dispatch({ type: createConfigSnapshotType, sections: getState().report.sections.slice(0) }),
    restoreConfig: () => (dispatch, getState) =>
        Array.isArray(getState().report.sections) && dispatch({ type: restoreConfigType, sections: getState().report.sections.slice(0) }),
    hideAllSections: () => (dispatch, getState) => dispatch({ type: toggleShowAllSectionsType, newHidden: true }),
    showAllSections: () => (dispatch, getState) => dispatch({ type: toggleShowAllSectionsType, newHidden: false }),
    toggleSectionEditMode: isEditMode => dispatch => dispatch({ type: toggleSectionsMenuEditType, isEditMode }),
    fetchMoreData: (path, params, dataHint, mergeFn, onSuccess = null, url = null) => async (dispatch, getState) =>
        getMoreSectionData(params, path, dataHint, mergeFn, onSuccess, url, dispatch, getState),
    resolveExpanded: (expanded, isExpandedTouched) => (_, getState) => resolveExpanded(expanded, isExpandedTouched, getState),
    scrollToSection: (topSection, simpleSection, hasSectionData) => (dispatch, getState) =>
        scrollToSection(topSection, simpleSection, hasSectionData, dispatch, getState),
    sectionFocused: () => dispatch => sectionFocused(dispatch),
    scrollToElement: (element, multiple, behavior) => (_, getState) => scrollToElement(element, multiple, behavior, getState),
    setSectionParams,
    reloadReport,
    getSectionLimits: (report, sectionId) => (_) => getSectionLimits(report, sectionId),
    getUnlimitedSectionLink,
    requestRelatedAddressData: (id, addressId) => async (dispatch, getState) => requestRelatedAddressData(id, addressId, dispatch, getState),
    raiseSectionError: (path, err) => (dispatch, getState) => dispatch({ type: errorReportSection, path: path.slice(0), err }),
    getEgReportSettings: (share, filter, entityID) => (dispatch, getState) => getDefaultEssValues(getState, dispatch, share, filter, null, entityID, null, null, true),
    egDataReloaded: () => (dispatch) => dispatch({ type: egDataLoaded, economicGroupSettings: { reload: false } }),
    cancelReportReload: () => dispatch => dispatch({ type: cancelReportReload }),
    setCustomizableMspImportData: (data) => async (dispatch) => dispatch({ type: setCustomizableMspImportData, data: data }),
    setCompanyInDifficultyExportUsed: (value) => dispatch => dispatch({ type: companyInDifficultyExportUsedChange, value })
};

// store reducer
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case LOCATION_CHANGE:
            return updateObject(state, { location: action.payload.pathname });
        case requestGetReportType:
            return updateObject(state, { isLoading: true, id: null, reportType: null, sections: null, isPdfExportEnabled: true });
        case receiveGetReportType:
            return updateObject(state, { isLoading: false, id: action.id, requestedReload: false, reportType: action.reportType, sections: action.data, isExpandAllActivated: false, isHideAllActivated: false });
        case errorGetReportType:
            return updateObject(state, { isLoading: false, requestedReload: false });
        case reorderSections:
            return updateObject(state, { sections: action.repSections });
        case updateReportSection:
            let intermediate = state;
            if (action.additionalData && action.additionalData.operation && action.additionalData.operation.toLowerCase() === 'update') {
                const subsections = updateSubsections(action.additionalData.subsections, getBaseUrl(state), getEntityId(state), state.isExpandAllActivated, getRepiReport(state));
                intermediate = updateObject(state, { sections: updateSection(state.sections, action.additionalData.path, { subsections }) });

            }
            return updateObject(
                intermediate,
                {
                    sections: updateSection(intermediate.sections, action.path, { isLoading: false, data: action.data, dataHash: sha1(JSON.stringify(action.data)).toString().toUpperCase(), error: null, hasData: action.hasData })
                }
            );
        case requestReportSection:
            return updateObject(state, { sections: updateSection(state.sections, action.path, { isLoading: true, data: null, error: null, params: action.params }) });
        case errorReportSection:
            return updateObject(state, { sections: updateSection(state.sections, action.path, { isLoading: false, data: null, error: action.err }) });
        case attachElement:
            return updateObject(state, { elements: updateObjectProperty(state.elements, action.sectionId, action.element) });
        case expandSection:
            return updateObject(state, { sections: updateSection(state.sections, action.sectionId, { expanded: action.newExpanded }) });
        case sectionParamChange:
            return updateObject(state, { sections: updateSection(state.sections, action.sectionId, { params: action.newParams }) });
        case expandSubsection:
            return updateObject(state, { sections: updateSection(state.sections, action.sectionId.concat(action.subsectionId), { expanded: action.newExpanded }) });
        case toggleShow:
            return updateObject(state, { sections: updateSection(state.sections, action.sectionId.slice(0), { hidden: action.newHidden }) });
        case sectionIdPdf:
            return updateObject(state, { sections: updateSection(state.sections, action.sectionId.slice(0), { historyInPdf: action.historyInPdf, inPdf: action.inPdf }), isPdfExportEnabled: true });
        case exportReportToPdf:
            return updateObject(state, { isPdfExportEnabled: false });
        case reportLeaving:
            return updateObject(state, { focusedSectionId: '', isExpandAllActivated: false, isHideAllActivated: false, customizableMspImportData: { hasItems: false, items: [], invalidFile: false } });
        case createConfigSnapshotType: {
            return updateObject(state, {
                sections: action.sections.map(section =>
                    ({ ...section, hiddenSnapshot: section.hidden, orderIdSnapshot: section.orderId })
                )
            });
        }
        case reportReload:
            return updateObject(state, { requestedReload: true });
        case cancelReportReload:
            return updateObject(state, { requestedReload: false });
        case restoreConfigType:
            return updateObject(state, {
                sections: action.sections.slice(0)
                    .sort(
                        (a, b) => (a.orderIdSnapshot ? a.orderIdSnapshot : a.orderId) - (b.orderIdSnapshot ? b.orderIdSnapshot : b.orderId)
                    ).map(section => ({
                        ...section,
                        hidden: isNullOrUndefined(section.hiddenSnapshot) ? section.hidden : section.hiddenSnapshot,
                        orderId: (section.orderIdSnapshot ? section.orderIdSnapshot : section.orderId)
                    }))
            });
        case saveConfigType:
            return updateObject(state, {
                sections: action.sections.map(section =>
                    ({ ...section, hiddenSnapshot: section.hidden, orderIdSnapshot: section.orderId })
                )
            });
        case toggleShowAllSectionsType:
            return updateObject(state,
                {
                    sections: state.sections.map(section => ({ ...section, hidden: section.id === SECTIONS.identData ? false : action.newHidden })),
                    showHideAllSections: !action.newHidden
                });
        case expandAllSections:
            return updateObject(state, { isExpandAllActivated: true, isHideAllActivated: false, sections: updateSubsectionsExpanded(state.sections, true) });
        case hideAllSections:
            return updateObject(state, { isExpandAllActivated: false, isHideAllActivated: true, sections: updateSubsectionsExpanded(state.sections, false) });
        case moreSectionData:
            return updateObject(state, { sections: updateSection(state.sections, action.path, { loadingMoreData: true }) });
        case moreSectionDataSuccess:
            var sectionData = getSection(state.sections, action.path.slice(0));
            const newData = action.mergeFn(action.dataHint, sectionData.data, action.data);
            const dataHash = sha1(JSON.stringify(newData)).toString().toUpperCase()
            return updateObject(state, {
                sections: updateSection(state.sections, action.path.slice(0), { loadingMoreData: false, data: newData, dataHash: dataHash })
            });
        case moreSectionDataError:
            return updateObject(state, { sections: updateSection(state.sections, action.path, { loadingMoreData: false, error: action.err }) });
        case expandSimpleSubsection:
            return updateObject(state, { sectionToFocus: action.section });
        case sectionFocusedType:
            return updateObject(state, { sectionToFocus: null });
        case relatedAddressRequest:
            return updateObject(state, { relatedAddress: { id: null, data: null, isLoading: true, error: null } });
        case relatedAddressSuccess:
            return updateObject(state, { relatedAddress: { id: action.id, data: action.data, isLoading: false, error: null } });
        case relatedAddressError:
            return updateObject(state, { relatedAddress: { id: null, data: null, isLoading: false, error: action.err } });
        case userLogout:
            return updateObject(state, { requestedReload: true });
        case essDefaultShare:
            return updateObject(state, { requestedReload: true, economicGroupSettings: action.economicGroupSettings });
        case saveEconomicGroupEntity:
            return updateObject(state, { economicGroupSettings: action.economicGroupSettings });
        case egDataLoaded:
            return updateObject(state, { economicGroupSettings: { reload: false } });
        case setCustomizableMspImportData:
            return updateObject(state, { requestedReload: true, customizableMspImportData: action.data.data });
        case companyInDifficultyExportUsedChange:
            return updateObject(state, { companyInDifficultyExportUsed: action.value });
        default:
            return state;
    }
}

function getBaseUrl(state) {
    let sectionFilter = "";
    if (Array.isArray(state.sectionFilter) && state.sectionFilter.length > 0)
        sectionFilter = "?sectionFilter=" + encodeURIComponent(state.sectionFilter.join("|"));

    return window.babylonApiUrl + `/api/report/${state.reportType}/${state.id}${sectionFilter}`;
}
function getSectionUrl(id, section, repiReport = null) {
    return isNullOrUndefined(repiReport)
        ? `${window.babylonApiUrl}/api/report/${id}/${section.link}`
        : `${window.babylonApiUrl}/api/repi/report/${repiReport}/${id}/${section.link}`;
}

function getConfigUrl(reportType) {
    return window.babylonApiUrl + `/api/report/${reportType}/config`;
}

function getEntityId(state) {
    return state.id;
}

function getRepiReport(state) {
    return isNullOrUndefined(state.reportType) || !state.reportType.startsWith("Repi") ? null : state.reportType.replace("Repi", "");
}

function createBaseSectionSettings(section) {
    return {
        id: section.id,
        expanded: section.expanded,
        hidden: section.hidden,
        orderId: section.orderId,
        params: section.params,
        inPdf: section.inPdf,
        historyInPdf: section.historyInPdf
    }
}

function requestFetchSection(sectionId, params, dispatch, getState, sectionToFocus, onSuccess) {
    dispatch({ type: requestReportSection, path: sectionId.slice(0), params: params });
    const report = getState().report;
    const sectionData = getSection(report.sections, sectionId.slice(0));
    if (isNullOrUndefined(sectionData)) {
        dispatch({ type: errorReportSection, path: sectionId.slice(0), err: `Report ${report.reportType} does not contains section ${sectionId.join(".")}` });
        return;
    }

    // Use economic group settings for economic group data section
    if (sectionId[0] === SECTIONS.economicGroupData) {
        sectionData.params = getState().report.economicGroupSettings;
    }

    const limitedParams = getLimitedParams(report.reportType, sectionData.id, sectionData.isLimited);
    const newParams = { ...sectionData.params, report: getState().report.reportType, guid: sectionData.guid, ...limitedParams };
    apiGet(sectionData.url, newParams,
        res => {
            if (res.error) {
                dispatch({ type: errorReportSection, path: sectionId.slice(0), err: processErrorMessage(res.error, "UnhappyUser.SectionError") });
                manageSectionStatusCheckScheduler(sectionId, dispatch, getState);
            } else {
                dispatch({ type: updateReportSection, path: sectionId.slice(0), sectionToFocus, ...res });
                manageSectionStatusCheckScheduler(sectionId, dispatch, getState, res.ok ? res.data : undefined);
                typeof onSuccess === 'function' && onSuccess(res.data);
            }
        },
        err => {
            dispatch({ type: errorReportSection, path: sectionId.slice(0), err: processErrorMessage(err, "UnhappyUser.SectionError") });
            manageSectionStatusCheckScheduler(sectionId, dispatch, getState);
        }
    );
};

function requestRelatedAddressData(id, addressId, dispatch, getState) {
    const relatedAddress = getState().relatedAddress;
    if (isNullOrUndefined(relatedAddress) || isNullOrUndefined(relatedAddress.data) || isNullOrUndefined(relatedAddress.id) || relatedAddress.id !== addressId) {
        dispatch({ type: relatedAddressRequest });
        const report = getState().report;
        const sectionData = getSection(report.sections, [SECTIONS.relationsData]);

        const newParams = { report: isNullOrUndefined(report.reportType) ? "GlobalReport" : report.reportType, guid: isNullOrUndefined(sectionData) ? null : sectionData.guid };
        apiGet(`${window.babylonApiUrl}/api/report/${id}/relation-address/${addressId}`, newParams,
            res => {
                if (res.error) {
                    dispatch({ type: relatedAddressError, err: processErrorMessage(res.error, "UnhappyUser.SectionError") });
                } else {
                    dispatch({ type: relatedAddressSuccess, id: addressId, data: res.data });
                }
            },
            err => {
                dispatch({ type: relatedAddressError, err: processErrorMessage(err, "UnhappyUser.SectionError") });
            }
        );
    }
};

function expandIfNeeded(sectionId, dispatch, getState, expandState, withTimeout) {
    if (!Array.isArray(sectionId)) {
        sectionId = [sectionId];
    }
    if (getSection(getState().report.sections, sectionId.slice(0)) === undefined) {
        return null;
    }

    const { data, expanded, params, hasAsyncContent, isLoading } = getSection(getState().report.sections, sectionId.slice(0));
    if ((data === null || data === undefined || (hasAsyncContent === true && data.reportStatus === 'inProgress')) && (expandState || expanded) && !isLoading) {
        setTimeout((sectionId, params, dispatch, getState) => {
            writeInfo('Loading expanded section ' + sectionId);
            // Use economic group settings for economic group data section
            if (sectionId[0] === SECTIONS.economicGroupData) {
                const report = getState().report;
                if (report.economicGroupSettings.entityID !== report.id) {
                    getDefaultEssValues(getState, dispatch, report.economicGroupSettings.share, report.economicGroupSettings.filter, report.id, report.economicGroupSettings.entityID, sectionId.slice(0), params, false);
                } else {
                    requestFetchSection(sectionId.slice(0), params, dispatch, getState);
                }
            } else {
                requestFetchSection(sectionId.slice(0), params, dispatch, getState);
            }
        }, withTimeout ? getTimeout(sectionId.slice(0), getState) : 0, sectionId.slice(0), params, dispatch, getState);
    }
}

function getTimeout(sectionId, getState) {
    let sections = getState().report.sections;
    sectionId.filter((_, index) => index < sectionId.length - 1).forEach(id => {
        sections = sections.find(section => section.id === id).subsections;
    });
    const rank = sections
        .filter(section => !section.hidden && section.expanded)
        .sort((s1, s2) => s1.orderId - s2.orderId)
        .findIndex(section => section.id === sectionId[sectionId.length - 1]);
    return rank * 500;
}

function updateSubsections(data, baseUrl, id, isExpandAllActivated, repiReport = null) {
    if (isNullOrUndefined(data))
        return data;
    return data.map(d => Object.assign(
        { ...d },
        { isLoading: false, url: getSectionUrl(id, d, repiReport), subsections: updateSubsections(d.subsections, baseUrl, id, repiReport) },
        isExpandAllActivated ? { expanded: true } : {}
    ));
}

function updateSubsectionsExpanded(data, expanded) {
    if (isNullOrUndefined(data))
        return data;
    return data.map(d => Object.assign({ ...d }, { expanded, subsections: updateSubsectionsExpanded(d.subsections, expanded) }));
}

function expandAllSectionsFunc(dispatch, getState) {
    dispatch({ type: expandAllSections });
}

function collapseAllSectionsFunc(dispatch, getState) {
    dispatch({ type: hideAllSections });
}

function getSection(sections, path, fromEnd) {
    if (isNullOrUndefined(sections) || sections.length === 0)
        return null;
    const end = fromEnd || 0;
    var sid = path.shift();
    writeDebug("Request for section data:" + sid);
    if (path && path.length === end)
        return sections.find(sec => sec.id === sid);
    const section = sections.find(sec => sec.id === sid);
    return isNullOrUndefined(section) || isNullOrUndefined(section.subsections) ? null : getSection(section.subsections, path);
}

const updateSingleSectionConfig = (reportType, section, after) => {
    apiPut(`${getConfigUrl(reportType)}/single-section`, undefined, createBaseSectionSettings(section),
        () => writeInfo('Single report section config successfuly updated'),
        () => writeWarn('Single report section config not updated'),
        () => { if (isFunction(after)) { after(); } });
}
const updateSingleSectionConfigDebounced = AwesomeDebouncePromise(updateSingleSectionConfig, 500, { key: (_, section) => section.Id });

const updateSectionsConfig = (reportType, sections) => {
    apiPut(`${getConfigUrl(reportType)}/sections`, undefined, sections.map(section => createBaseSectionSettings(section)),
        () => writeInfo('Report sections config successfuly updated'),
        () => writeWarn('Report sections config not updated'));
}
const updateSectionsConfigDebounced = AwesomeDebouncePromise(updateSectionsConfig, 500);

function onResetSectionsOrder(sections, dispatch, getState) {
    apiGet(`${getConfigUrl(getState().report.reportType)}/default-sections`, undefined,
        res => {
            if (res.error) {
                dispatch({ type: errorType, message: processErrorMessage({ data: res }) });
            } else {
                const defaultSections = res.data;

                let reportSections = [...getState().report.sections];
                for (let idx = 0; idx < reportSections.length; idx++) {
                    reportSections[idx].orderId = (defaultSections.filter(x => x.id == reportSections[idx].id)[0] || {}).orderId || 0;
                }
                reportSections = reportSections.sort(function (a, b) { return a.orderId - b.orderId; });

                let navSections = [...sections];
                for (let idx = 0; idx < navSections.length; idx++) {
                    navSections[idx].orderId = (defaultSections.filter(x => x.id == navSections[idx].id)[0] || {}).orderId || 0;
                }
                navSections = navSections.sort(function (a, b) { return a.orderId - b.orderId; });

                dispatch({ type: reorderSections, repSections: reportSections.slice(0), navSections: navSections.slice(0) });
            }
        },
        err => {
            dispatch({ type: errorType, message: processErrorMessage(err) });
        });
}

let timers = {};

function scheduleStatusCheck(sectionId, dispatch, getState) {
    const key = sectionId.join('$');
    clearTimeout(timers[key]);
    timers[key] = setTimeout(relevantSectionId => {
        const relevantSectionKey = relevantSectionId.join('$');
        writeDebug("Status check tick for report section '" + relevantSectionKey + "'");

        // check if previous report request is still running
        const reportSection = getSection(getState().report.sections, relevantSectionId.slice(0));
        if (reportSection && reportSection.isLoading === true) {
            writeDebug("Report section '" + relevantSectionKey + "' status check skipped (because aml status is already loading)");
            return; // prevent from running multiple same requests simultaneously
        }

        requestFetchSection(relevantSectionId, undefined, dispatch, getState);
    }, 10000, sectionId)
    writeDebug("Status check scheduled (or re-scheduled) for report section '" + key + "'");
}

function cancelScheduledStatusCheck(sectionId) {
    const key = sectionId.join('$');
    clearTimeout(timers[key]);
    writeDebug("Status check schedule cancelled for report section '" + key + "' (if any was scheduled)");
}

function cancelAllTimers() {
    Object.keys(timers).forEach(key => clearTimeout(timers[key]));
    writeDebug("Status check schedule canncelled for all report sections (Global report component will unmount)")
}

function manageSectionStatusCheckScheduler(sectionId, dispatch, getState, resultData) {
    const report = getState().report;
    if (isNullOrUndefined(report.reportType) || report.isLoading)
        return;
    const { hasAsyncContent, expanded, data } = getSection(report.sections, sectionId.slice(0));;
    const sectionData = (resultData === undefined || resultData === null) ? data : resultData;
    if (hasAsyncContent === true) {
        if (expanded === true && sectionData && sectionData.reportStatus === 'inProgress') {
            scheduleStatusCheck(sectionId, dispatch, getState);
        } else {
            cancelScheduledStatusCheck(sectionId);
        }
    }
}

function getMoreSectionData(params, path, dataHint, mergeFn, onSuccess, url, dispatch, getState) {
    dispatch({ type: moreSectionData, path: path.slice(0) });
    url = isNullOrUndefined(url) ? getSection(getState().report.sections, path.slice(0)).url : url;
    apiGet(url, params,
        res => {
            dispatch(Object.assign({ type: moreSectionDataSuccess, path: path.slice(0), dataHint, mergeFn }, res));
            manageSectionStatusCheckScheduler(path.slice(0), dispatch, getState, res.ok ? res.data : undefined);
            if (isFunction(onSuccess))
                onSuccess();
        },
        err => {
            dispatch({ type: moreSectionDataError, path: path.slice(0), err: processErrorMessage(err, "UnhappyUser.SectionError") });
            manageSectionStatusCheckScheduler(path.slice(0), dispatch, getState);
        }
    );
}

function resolveExpanded(expanded, isExpandedTouched, getState) {
    if (isExpandedTouched) {
        return expanded;
    } else {
        if (getState().report.isExpandAllActivated)
            return true;
        else if (getState().report.isHideAllActivated) {
            return false;
        } else {
            return expanded;
        }
    }
}

function scrollToSection(section, simpleSubsection, hasSectionData, dispatch, getState) { // only scrolling to topSection or its simpleSubsection is supported in this function
    if (section && !section.hidden) {
        if (section.expanded) {
            (!simpleSubsection || (typeof hasSectionData === 'function' && !hasSectionData(section.data))) ?
                scrollToElement(getState().report.elements[section.id], true, 'smooth', getState) :
                // dispatch that simple subsection should be expanded (and again focused for case that its expansion
                // would result in change of the section position) because we do not know if it is currently expanded.
                dispatch({ type: expandSimpleSubsection, section: simpleSubsection });
        }
        else {
            if (section.data) {
                if (simpleSubsection && typeof hasSectionData === 'function' && !hasSectionData(section.data)) {
                    scrollToElement(getState().report.elements[section.id], true, 'smooth', getState);
                } else {
                    dispatch({ type: expandSection, sectionId: [section.id], newExpanded: true, sectionToFocus: simpleSubsection || section.id });
                    // dispatch that simple subsection should be expanded (and again focused for case that its expansion would
                    // result in change of the section position) because we do not know if it is currently expanded.
                    simpleSubsection && dispatch({ type: expandSimpleSubsection, section: simpleSubsection });
                }
            } else {
                scrollToElement(getState().report.elements[section.id], true, 'smooth', getState);
                requestFetchSection([section.id], section.params, dispatch, getState, section.id, data => {
                    (typeof hasSectionData !== 'function' || hasSectionData(data)) && dispatch({
                        type: expandSection, sectionId: [section.id], newExpanded: true, sectionToFocus: simpleSubsection || section.id
                    });
                });
            }
            updateSingleSectionConfigDebounced(getState().report.reportType, getState().report.sections.find(i => i.id === section.id));
        }
    }
}

function sectionFocused(dispatch) {
    dispatch({ type: sectionFocusedType });
}

const scrollTimeouts = {}

function scrollToElement(element, multiple, behavior, getState) {
    multiple ?
        [0, 500, 1000].forEach(i => {
            clearTimeout(scrollTimeouts[i]);
            scrollTimeouts[i] = setTimeout(
                (element, behavior, getState) => performScroll(element, behavior, getState), i, element, behavior, getState
            );
        }) :
        performScroll(element, behavior, getState);
}

const performScroll = (element, behavior, getState) => {
    const position = element.offsetTop - 5
        - document.querySelector('#entity-row').clientHeight
        - document.querySelector('.content-body-wrapper').offsetTop;
    'scrollBehavior' in document.documentElement.style ?
        window.scrollTo({ top: position, behavior }) :
        window.scrollTo(0, position);
}

function getLimitedParams(reportType, sectionId, isLimited) {
    var limits = SECTION_LIMITS.find(f => f.id === sectionId && f.report === reportType);
    if (isNullOrUndefined(limits) && (sectionId.startsWith(`${SECTIONS.relationItems}_`) || sectionId.startsWith(`${SECTIONS.relationCRSRItems}_`)))
        limits = SECTION_LIMITS.find(f => sectionId.startsWith(f.id) && f.report === reportType);
    if (isNullOrUndefined(limits) || isNullOrUndefined(limits.params))
        return {};
    if (isLimited && !isNullOrUndefined(limits.params.limited))
        return limits.params.limited;
    if (!isLimited && !isNullOrUndefined(limits.params.unlimited))
        return limits.params.unlimited;
    return {};
}

function getSectionLimits(report, sectionId) {
    var limits = SECTION_LIMITS.find(f => f.id === sectionId && f.report === report);
    if (isNullOrUndefined(limits) && (sectionId.startsWith(`${SECTIONS.relationItems}_`) || sectionId.startsWith(`${SECTIONS.relationCRSRItems}_`)))
        limits = SECTION_LIMITS.find(f => sectionId.startsWith(f.id) && f.report === report);
    return isNullOrUndefined(limits) ? SECTION_LIMITS.find(f => f.id === `${report}${sectionId}` && f.report === report) : limits;
}

function getDefaultEssValues(getState, dispatch, share, filter, reportEntityId, egSettingsEntityId, sectionId, params, reloadReport) {
    if (reportEntityId !== egSettingsEntityId && reportEntityId !== null) {
        apiGet(`${getHostApi()}/api/account/settings`, null,
            (s) => {
                if (!isNullOrUndefined(s) && !isNullOrUndefined(s.data))
                    dispatch({ type: saveEconomicGroupEntity, economicGroupSettings: { share: !isNullOrUndefined(s.data.essShareDefaultUser) ? s.data.essShareDefaultUser : s.data.essShareDefault, filter: 'EG', entityID: reportEntityId, reload: true } })
            },
            (e) => console.error(e),
            () => {
                if (reloadReport) {
                    dispatch({ type: reportReload });
                } else {
                    requestFetchSection(sectionId, params, dispatch, getState);
                }
            })
    } else {
        dispatch({ type: essDefaultShare, economicGroupSettings: { share: share, filter: filter, entityID: egSettingsEntityId, reload: false } })
        dispatch({ type: reportReload });
    }
}
